<template>
    <div>
        <input
                type="text"
                class="form-control"
                :placeholder="trans('search')"
                v-model="search_string"
                @blur="blur_search"
        >

        <div class="warehouse-inventory-form__autocomplete-result-container" v-show="found_products.length > 0">
            <div class="warehouse-inventory-form__autocomplete-result__body">
                <ul class="list-group">
                    <li
                            v-for="product in found_products"
                            @click="goto_product(product)"
                            class="list-group-item warehouse-inventory-form__result-item"
                    >
                        {{product.name}}
                    </li>
                </ul>
            </div>
        </div>

        <div class="warehouse-inventory-form__brands">
            <div v-for="brand in brands" class="btn btn-default" @click="load_brand(brand.id)">{{brand.title}}</div>
        </div>

        <div class="warehouse-inventory-form__loaded-container" v-show="loaded_brand.id">
            <form :action="action_url" method="POST" ref="form">
            <input type="hidden" name="_token" :value="csrf">
            <div class="warehouse-inventory-form__save-button-container">
                <button type="submit" class="btn btn-primary" v-text="trans('save_button', null)"></button>
            </div>
            <br>

            <div class="panel panel-default">
                <div class="panel-heading">
                    <h4 class="panel-title">
                        {{ loaded_brand.title }}
                    </h4>
                </div>
                <div class="panel-body" v-if = "section === 'inventory'">
                    <inventory-products-form
                            :loaded_brand="loaded_brand"
                            :translations="translations"
                            :variant_reserves="variant_reserves"
                            :variant_total_prices="variant_total_prices"
                    ></inventory-products-form>
                </div>
                <div class="panel-body" v-else>
                    <incoming-products-form
                            :loaded_brand="loaded_brand"
                            :translations="translations"
                            :variant_reserves="variant_reserves"
                            :available_vats="available_vats"
                    ></incoming-products-form>
                </div>
            </div>

            <div class="warehouse-inventory-form__save-button-container">
                <button type="submit" class="btn btn-primary" v-text="trans('save_button', null)"></button>
            </div>
            </form>
        </div>
    </div>
</template>

<script>
let Functions = require("../../Functions");

export default {
    props: ['brands', 'section', 'translations'],
    data: function () {
        return {
            csrf: '',
            search_string: '',
            found_products: [],
            loaded_brand: {},
            variant_reserves: [],
            variant_total_prices: [],
            cache: {},
            is_now_scrolling: false,
            now_scrolling_to_product_id: 0,
            available_vats: [],
            action_url: "/warehouse/" + this.section + "/store_products",
        };
    },
    mounted: function () {
        let token = document.querySelector('#token').getAttribute('content');
        Vue.http.headers.common['X-CSRF-TOKEN'] = token;
        this.csrf = token;
    },
    updated: function () {
        if (this.is_now_scrolling) {
            this.scroll_to_product();
            this.is_now_scrolling = false;
        }
    },
    methods: {
        trans(name, path = 'stock') {
            return Functions.trans(this.translations, name, path);
        },
        blur_search: function () {
            setTimeout(function () {
                this.found_products = [];
            }, 1);
        },
        autocomplete: function (search_string) {
            this.clear();

            if (search_string.length < 3) {
                return;
            }

            if (search_string in this.cache) {
                this.found_products = this.get_from_cache(search_string);
                return;
            }

            let self = this;
            this.$http
                .post('/warehouse/inventory/autocomplete', {search_string: search_string})
                .then(function (response) {
                    self.found_products = response.data.products;
                    self.put_to_cache(search_string, response.data.products);
                });
        },
        loadingRoute() {
            return this.section === 'incoming'
                ? '/warehouse/incoming/load_brand'
                : '/warehouse/inventory/load_brand';
        },
        load_brand: function (brand_id, product_id = null) {
            this.clear();

            this.$http
                .post(this.loadingRoute(), {id: brand_id})
                .then((response) => {
                    this.loaded_brand = response.data.brand;
                    this.variant_reserves = response.data.variant_reserves || [];
                    this.available_vats = response.data.available_vats || [];
                    this.variant_total_prices = response.data.variant_total_prices || [];
                    if (product_id) {
                        this.run_scroll_process(product_id);
                    }
                });
        },
        goto_product: function (product) {
            this.load_brand(product.brand_id, product.id);
        },
        run_scroll_process: function (product_id) {
            this.is_now_scrolling = true;
            this.now_scrolling_to_product_id = product_id;
        },
        scroll_to_product: function () {
            let product_id = this.now_scrolling_to_product_id;
            let element = this.$el.querySelector("#product-" + product_id);
            element.style.backgroundColor = '#dedede';
            document.body.scrollTop = element.offsetTop;
        },
        clear: function () {
            this.found_products = [];
            this.loaded_brand = {};
        },
        get_from_cache: function (key) {
            return this.cache[key];
        },
        put_to_cache: function (key, search_result) {
            this.cache[key] = search_result;
        }
    },
    watch: {
        'search_string': function (val) {
            this.autocomplete(val);
        }
    }
};
</script>
